var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{style:(this.$vuetify.theme.dark ? 'background: #272727;' : 'background: #f5f5f5;')},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }